<script>
import advanceReportingConfigs from "@/configs/advanceReportingConfigs"
import queueConfigs from "@/configs/queueConfigs"
import retainExtraPassesConfigs from "@/configs/retainExtraPassesConfigs"
import visitorConfigs from "@/configs/visitorConfigs"
import moment from "moment-timezone"
import { mapGetters } from "vuex"

export default {
  name: "NavComponent",
  computed: {
    ...mapGetters({
      appPassesNotf: "studentAptPass/todaysAppSidebarCounter",
      user: "authentication/user",
      releases: "updates/releases",
      isUserUnavailable: "authentication/isUserUnavailable",
      unavailable: "dashboardTable/unavailable",
      isActiveTardyModule: "schools/isActiveTardyModule",
      tardyManagementOptions: "schools/tardyManagementOptions",
      isReportNew: "totalPassReports/isReportNew"
    }),
    isTardyAllowedForStudents() {
      return (
        this.isActiveTardyModule &&
        this.tardyManagementOptions?.["allow-students-see-level"]
      )
    },
    OutOfOfficeBadge() {
      return this.isUserUnavailable || this.unavailable ? "bg-green" : "d-none"
    },
    isReportNewBadge() {
      return this.isReportNew ? "bg-green" : "d-none"
    },
    sidebarItems() {
      return [
        {
          _name: "CSidebarNav",
          _children: [
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.digital_id"),
              to: "/id-card",
              fontIcon: "fi flaticon-profile-line",
              requiredRoles: ["student"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.create_pass"),
              to: "/passes/create",
              fontIcon: "fi flaticon-create-pass",
              requiredRoles: ["student"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.active_pass"),
              to: "/passes/activepass",
              fontIcon: "fi flaticon-compass",
              requiredRoles: ["student"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.consequences_ladder"),
              to: "/tardy/consequences-level",
              fontIcon: "fi flaticon-information",
              requiredRoles: ["student"],
              requiredModule: "Tardy Management",
              routeDependency: "routerDependencies/isStudentLadderVisible",
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.dashboard"),
              _attrs: {
                "data-test-class": "nav-item"
              },
              to: "/dashboard",
              fontIcon: "ri-dashboard-line",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"]
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.history"),
              to: "/history",
              fontIcon: "ri-history-line",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              hidden: true,
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.teacher_pass"),
              to: "/teacher-pass",
              fontIcon: "ri-door-open-line",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.appointments"),
              to: "/appointments",
              fontIcon: "ri-calendar-check-line",
              _attrs: {
                "data-test-id": "AppointmentPass",
                "data-test-class": "nav-item"
              },
              requiredRoles: [
                "superadmin",
                "admin",
                "teacher",
                "staff",
                "student"
              ],
              requiredModule: "Appointmentpass",
              routeDependency:
                "routerDependencies/hasAppointmentModuleRouteAccess",
              badge:
                this.appPassesNotf &&
                this.appPassesNotf > 0 &&
                this.user.role.name == "student"
                  ? {
                      _class: "bg-red-gradient text-white",
                      color: "bg-red-gradient text-white",
                      text: this.appPassesNotf
                    }
                  : {}
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.kiosk"),
              to: "/kiosk",
              _attrs: {
                "data-test-id": "Kiosk",
                "data-test-class": "nav-item"
              },
              fontIcon: "ri-device-line",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              requiredModule: "Kiosk"
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.out_of_office"),
              to: "/out-of-office",
              fontIcon: "ri-suitcase-3-line",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-id": "out-of-office"
              },
              badge: {
                color: this.OutOfOfficeBadge,
                text: "ON"
              }
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.tardy_management"),
              to: "/tardy-management/",
              fontIcon: "ri-alarm-line",
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              requiredModule: "Tardy Management",
              routeDependency: "routerDependencies/isVisibleTardyManagment",
              items: [
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.tardy_reports"),
                  to: "/tardy-management/reports",
                  fontIcon: "fi flaticon-information",
                  "data-test-class": "nav-item",
                  requiredRoles: ["superadmin", "admin", "teacher", "staff"]
                },
                {
                  component: "CNavItem",
                  name: this.$t(
                    "sidebar_items.tardy_detention_appointment_list"
                  ),
                  to: "/tardy-management/detentions-appointments",
                  fontIcon: "fi flaticon-information",
                  "data-test-class": "nav-item",
                  requiredRoles: ["superadmin", "admin", "teacher", "staff"]
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t(
                visitorConfigs.pages.managementPage().i18n_name_key
              ),
              to: visitorConfigs.pages.managementPage().path,
              fontIcon: "ri-user-line",
              requiredRoles: visitorConfigs.pages.managementPage().roles,
              requiredModule: visitorConfigs.pages.managementPage().module,
              routeDependency: visitorConfigs.pages.managementPage().dependency,
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: this.$t(
                    visitorConfigs.pages.checkInLogsPage().i18n_name_key
                  ),
                  to: visitorConfigs.pages.checkInLogsPage().path,
                  "data-test-class": "nav-item",
                  requiredRoles: visitorConfigs.pages.checkInLogsPage().roles,
                  routeDependency:
                    visitorConfigs.pages.checkInLogsPage().dependency
                },
                {
                  component: "CNavItem",
                  name: this.$t(
                    visitorConfigs.pages.printerPage().i18n_name_key
                  ),
                  to: visitorConfigs.pages.printerPage().path,
                  "data-test-class": "nav-item",
                  requiredRoles: visitorConfigs.pages.printerPage().roles,
                  routeDependency: visitorConfigs.pages.printerPage().dependency
                }
              ]
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.updates"),
              to: "/updates",
              fontIcon: "ri-radar-line",
              _attrs: {
                "data-test-class": "nav-item"
              },
              requiredRoles: [
                "superadmin",
                "admin",
                "teacher",
                "staff",
                "student"
              ],
              badge:
                this.newReleases.length > 0
                  ? {
                      color: "bg-gradient-blue",
                      text: "NEW"
                    }
                  : {}
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.training"),
              to: "/training/",
              fontIcon: "ri-information-line",
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              requiredRoles: [
                "superadmin",
                "admin",
                "teacher",
                "staff",
                "student"
              ],
              items: [
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.documents"),
                  to: "/training/documents",
                  fontIcon: "fi flaticon-pencil",
                  _attrs: {
                    "data-test-class": "nav-item"
                  },
                  requiredRoles: [
                    "superadmin",
                    "admin",
                    "teacher",
                    "staff",
                    "student"
                  ]
                },
                {
                  name: this.$t("sidebar_items.video_tutorials"),
                  component: "CNavItem",
                  to: "/training/videos",
                  fontIcon: "fi flaticon-video",
                  _attrs: {
                    "data-test-class": "nav-item"
                  },
                  requiredRoles: [
                    "superadmin",
                    "admin",
                    "teacher",
                    "staff",
                    "student"
                  ]
                }
              ]
            },
            {
              _name: "CSidebarNavTitle",
              component: "CNavTitle",
              _children: [this.$t("sidebar_items.control_panel")],
              name: this.$t("sidebar_items.control_panel"),
              requiredRoles: ["superadmin", "admin"]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.district_school_insights"),
              to: "/district-school-insights",
              fontIcon: "ri-lightbulb-line",
              requiredRoles: ["superadmin", "admin"],
              routeDependency:
                advanceReportingConfigs.pages.mainPage().dependency,
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: this.$t(
                    advanceReportingConfigs.pages.mainPage().i18n_name_key
                  ),
                  to: advanceReportingConfigs.pages.mainPage().path,
                  requiredRoles: advanceReportingConfigs.pages.mainPage().roles,
                  routeDependency:
                    advanceReportingConfigs.pages.mainPage().dependency,
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t(
                    advanceReportingConfigs.pages.scheduledReportsPage()
                      .i18n_name_key
                  ),
                  to: advanceReportingConfigs.pages.scheduledReportsPage().path,
                  requiredRoles:
                    advanceReportingConfigs.pages.scheduledReportsPage().roles,
                  routeDependency:
                    advanceReportingConfigs.pages.scheduledReportsPage()
                      .dependency,
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.reports"),
              to: "/reports",
              fontIcon: "ri-survey-line",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  name: this.$t("sidebar_items.summary_reports"),
                  component: "CNavItem",
                  to: "/reports/summary-reports",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.meet_up_report"),
                  to: "/reports/meet-up-report",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.pass_totals"),
                  to: "/reports/pass-totals",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  },
                  badge: {
                    color: this.isReportNewBadge,
                    text: "New"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.tardy_settings"),
              to: "/tardy-settings",
              fontIcon: "ri-settings-6-line",
              requiredRoles: ["superadmin", "admin"],
              requiredModule: "Tardy Management",
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.tardy_adults"),
                  to: "/tardy-management/adults",
                  "data-test-class": "nav-item",
                  requiredRoles: ["superadmin", "admin"],
                  routeDependency: "routerDependencies/isVisibleTardyAdults"
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.tardy_csv_upload"),
                  to: "/tardy-management/tardy-csv-upload",
                  "data-test-class": "nav-item",
                  requiredRoles: ["superadmin", "admin", "teacher", "staff"],
                  routeDependency: "routerDependencies/isVisibleTardyCSVUpload"
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.tardy_detentions"),
                  to: "/tardy-settings/setup-detention",
                  requiredRoles: ["superadmin", "admin"],
                  "data-test-class": "nav-item"
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.detention_calendar"),
                  to: "/tardy-management/detention-calendar",
                  fontIcon: "fi flaticon-information",
                  requiredRoles: ["superadmin", "admin"]
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.consequences_ladder"),
                  to: "/tardy-settings/consequences",
                  requiredRoles: ["superadmin", "admin"],
                  "data-test-class": "nav-item"
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.visitor_settings"),
              to: visitorConfigs.pages.settingsPage().path,
              fontIcon: "ri-user-line",
              requiredRoles: visitorConfigs.pages.settingsPage().roles,
              requiredModule: visitorConfigs.pages.settingsPage().module,
              routeDependency: visitorConfigs.pages.settingsPage().dependency,
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.visitor_adults"),
                  to: visitorConfigs.pages.adultsPage().path,
                  "data-test-class": "nav-item",
                  requiredRoles: visitorConfigs.pages.adultsPage().roles,
                  routeDependency: visitorConfigs.pages.adultsPage().dependency
                },
                {
                  component: "CNavItem",
                  name: this.$t(
                    "sidebar_items.visitor_guardian_student_matrix"
                  ),
                  to: visitorConfigs.pages.guardianStudentMatrixPage().path,
                  "data-test-class": "nav-item",
                  requiredRoles:
                    visitorConfigs.pages.guardianStudentMatrixPage().roles,
                  routeDependency:
                    visitorConfigs.pages.guardianStudentMatrixPage().dependency
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.general_settings"),
                  to: visitorConfigs.pages.generalPage().path,
                  "data-test-class": "nav-item",
                  requiredRoles: visitorConfigs.pages.generalPage().roles,
                  routeDependency: visitorConfigs.pages.generalPage().dependency
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.kiosk_settings"),
                  to: visitorConfigs.pages.kioskPage().path,
                  "data-test-class": "nav-item",
                  requiredRoles: visitorConfigs.pages.kioskPage().roles,
                  routeDependency: visitorConfigs.pages.kioskPage().dependency
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.list_settings"),
                  to: visitorConfigs.pages.listPage().path,
                  "data-test-class": "nav-item",
                  requiredRoles: visitorConfigs.pages.listPage().roles,
                  routeDependency: visitorConfigs.pages.listPage().dependency
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.security_alerts_settings"),
                  to: visitorConfigs.pages.securityPage().path,
                  "data-test-class": "nav-item",
                  requiredRoles: visitorConfigs.pages.securityPage().roles,
                  routeDependency:
                    visitorConfigs.pages.securityPage().dependency
                }
              ]
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t(queueConfigs.pages.settingsPage().i18n_name_key),
              to: queueConfigs.pages.settingsPage().path,
              fontIcon: "ri-group-line",
              requiredRoles: queueConfigs.pages.settingsPage().roles,
              requiredModule: queueConfigs.pages.settingsPage().module,
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.limits"),
              to: "/limits",
              fontIcon: "ri-dashboard-2-line",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.limit_student_pass"),
                  to: "/limits/limit-student-pass",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.limit_location_max_cap"),
                  to: "/limits/limit-location-max-cap",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.limit_active_pass"),
                  to: "/limits/limit-active-pass",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.limit_location_availability"),
                  to: "/limits/limit-location-availability",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.contact_control_ab_polarity"),
                  to: "/limits/ab-polarity",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.pass_blocking"),
                  to: "/limits/pass-blocking",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.users"),
              to: "/users/main-users",
              fontIcon: "ri-user-settings-line",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.main_users"),
                  to: "/users/main-users",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.substitute_users"),
                  to: "/users/substitute-users",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.archived_users"),
                  to: "/users/archived-users",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: this.$t("sidebar_items.system_settings"),
              to: "/system-settings",
              fontIcon: "ri-sound-module-line",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.auto_pass"),
                  to: "/system-settings/auto-pass",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.pass_times"),
                  to: "/system-settings/pass-times",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.periods"),
                  to: "/system-settings/periods",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.locations_rooms"),
                  to: "/system-settings/rooms",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: this.$t("sidebar_items.pass_transparency"),
                  to: "/system-settings/pass-transparency",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.modules"),
              to: "/modules",
              fontIcon: "ri-list-settings-line",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.file_uploads"),
              to: "/file-uploads",
              fontIcon: "ri-upload-2-line",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t(
                retainExtraPassesConfigs.pages.listPage().i18n_name_key
              ),
              to: retainExtraPassesConfigs.pages.listPage().path,
              fontIcon: "ri-archive-line",
              requiredRoles: retainExtraPassesConfigs.pages.listPage().roles,
              routeDependency:
                retainExtraPassesConfigs.pages.listPage().dependency,
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: this.$t("sidebar_items.help_desk"),
              to: "/help-desk",
              fontIcon: "ri-lightbulb-line",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            }
          ]
        }
      ]
    },
    nextSevenDays() {
      const today = moment().format("MM/DD/YYYY")
      const nextSevenDays = moment().add(7, "days").format("MM/DD/YYYY")
      return today.toString() + "," + nextSevenDays.toString()
    },
    isActiveAppoinmentModule() {
      return this.$store.getters["schools/isActiveAppoinmentModule"]
    }
  },
  methods: {
    getLadders() {
      if (this.user.role.name == "student" && this.isTardyAllowedForStudents) {
        this.$store.dispatch("consequencesLadder/getAllLadders")
      }
    },
    getStudentAptPasses() {
      if (this.user.role.name == "student") {
        this.$store.dispatch("studentAptPass/getTodaysAppointmentPasses")
      }
    }
  },
  created() {
    this.getLadders()
    this.getStudentAptPasses()
  },
  watch: {
    isTardyAllowedForStudents() {
      this.getLadders()
    }
  }
}
</script>
